export default () => '/?logout=true'
